var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "rgba(229, 24, 55, 1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99968 4.5C9.2633 4.5 8.66634 5.09695 8.66634 5.83333C8.66634 6.56971 9.2633 7.16667 9.99968 7.16667C10.7361 7.16667 11.333 6.56971 11.333 5.83333C11.333 5.09695 10.7361 4.5 9.99968 4.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 16.5L8.66634 16.5L8.66634 8.5L11.333 8.5L11.333 16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteExclamation);
export default __webpack_public_path__ + "static/media/white_exclamation.825cae9c43f90df2b99af751ab63ff94.svg";
export { ForwardRef as ReactComponent };